import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { MagicLampsRays } from './MagicLampsRays';
import { magicLampsAnim } from './MagicLampsAnim';

interface MagicLampsGrandPrizeOpts extends ViewOpts {
  amount: number;
}

export class MagicLampsGrandPrize extends View {
  private rays: MagicLampsRays;
  private base: ImageScaleView;
  private icon: ImageScaleView;
  private text: LangBitmapFontTextView;
  private amount: LangBitmapFontTextView;
  private baseScale: number;

  constructor(opts: MagicLampsGrandPrizeOpts) {
    super({ ...opts });

    this.baseScale = opts.scale || 1;

    this.rays = new MagicLampsRays({
      superview: this,
      width: 300,
      height: 300,
    });

    this.base = new ImageScaleView({
      superview: this,
      width: 152,
      height: 146,
      image: `assets/ui/match2/magiclamps/magiclamps_grand_prize.png`,
      centerAnchor: true,
      centerOnOrigin: true,
    });

    this.icon = new ImageScaleView({
      superview: this,
      width: 100,
      height: 100,
      y: -40,
      image: `assets/ui/match2/magiclamps/magiclamps_grand_prize_icon.png`,
      centerAnchor: true,
      centerOnOrigin: true,
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: -2,
      y: 6,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 24,
      font: 'Title',
      width: this.base.style.width - 26,
      height: 30,
      wordWrap: true,
    });
    this.text.localeText = () => i18n('match2.magicLamps.grandPrize');

    this.amount = new LangBitmapFontTextView({
      superview: this,
      x: -2,
      y: 32,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 20,
      color: '#3B0076',
      font: 'Body',
      width: this.base.style.width - 26,
      height: 30,
      wordWrap: true,
    });
    this.amount.localeText = () => `x${opts.amount}`;
  }

  public async shineAnimated() {
    const scale = this.baseScale * 1.2;
    void magicLampsAnim(this, { scale }, 300, animate.easeOutBack);
    await this.rays.showAnimated();
  }

  public async unshineAnimated() {
    const scale = this.baseScale * 1.2;
    void magicLampsAnim(this, { scale }, 200, animate.easeOut);
    await this.rays.hideAnimated();
  }
}
